import { render, staticRenderFns } from "./FaturaDespesa.vue?vue&type=template&id=219dba94"
import script from "./FaturaDespesa.vue?vue&type=script&lang=js"
export * from "./FaturaDespesa.vue?vue&type=script&lang=js"
import style0 from "./FaturaDespesa.vue?vue&type=style&index=0&id=219dba94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports